import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { FIRST_PRICE_DISPLAY_TYPE } from './ServicesList.constants';
import { getScheduleCategories, getCategoryProps, getInitialActiveIndices } from './ServicesList.utils';
import { ServicesListCategory } from './components';
import { PriceDisplayTypePropTypes } from './types/price-display';
import Accordion from '../../../foundation/components/Accordion';
import { MenuCatalogSchedulePropType, MenuCatalogCategoryPropType, MenuCatalogItemPropType, MenuCatalogModifierSetPropType, MenuCatalogModifierPropType } from '../../types/menu-catalog';
import './ServicesList.css';
var defaultProps = {
  defaultAllOpen: false,
  initialActiveIndices: [],
  priceDisplayType: FIRST_PRICE_DISPLAY_TYPE,
  displayZeroCostItemPrices: false,
  precision: 2,
  className: '',
  animated: false
};
export default function ServicesList(_ref) {
  var defaultAllOpen = _ref.defaultAllOpen,
    catalog = _ref.catalog,
    initialActiveIndices = _ref.initialActiveIndices,
    priceDisplayType = _ref.priceDisplayType,
    displayZeroCostItemPrices = _ref.displayZeroCostItemPrices,
    precision = _ref.precision,
    className = _ref.className,
    animated = _ref.animated;
  var _catalog$schedules = catalog.schedules,
    schedules = _catalog$schedules === void 0 ? [] : _catalog$schedules,
    _catalog$categories = catalog.categories,
    categories = _catalog$categories === void 0 ? [] : _catalog$categories;
  var finalCategories = getScheduleCategories(schedules, categories);
  if (_isEmpty(finalCategories)) {
    return null;
  }
  var finalInitialActiveIndices = getInitialActiveIndices(initialActiveIndices, finalCategories, defaultAllOpen);
  var _useState = useState(finalInitialActiveIndices),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndices = _useState2[0],
    setActiveIndices = _useState2[1];
  function onCategoryClick(e, _ref2) {
    var categoryIndex = _ref2.index;
    // Accordion open/close is disabled when only one category
    if (!finalCategories.length > 1) {
      return;
    }
    setActiveIndices(function (previousActiveIndices) {
      if (previousActiveIndices.includes(categoryIndex)) {
        return previousActiveIndices.filter(function (currentIndex) {
          return currentIndex !== categoryIndex;
        });
      }
      return [].concat(_toConsumableArray(previousActiveIndices), [categoryIndex]);
    });
  }
  return /*#__PURE__*/React.createElement(Accordion, {
    className: className
  }, finalCategories.map(function (category, index) {
    var categoryProps = getCategoryProps(category, {
      defaultAllOpen: defaultAllOpen,
      catalog: catalog
    });
    var _ref3 = categoryProps || {},
      _ref3$items = _ref3.items,
      items = _ref3$items === void 0 ? [] : _ref3$items;
    var displayToggle = items.length >= 1;
    return /*#__PURE__*/React.createElement(ServicesListCategory, _extends({}, categoryProps, {
      key: _get(category, '_id', index),
      index: index,
      active: activeIndices.includes(index),
      onClick: onCategoryClick,
      priceDisplayType: priceDisplayType,
      displayZeroCostItemPrices: displayZeroCostItemPrices,
      displayToggle: displayToggle,
      precision: precision,
      animated: animated
    }));
  }));
}
ServicesList.defaultProps = defaultProps;